import type { FC } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Typography } from "../Typography";

import type { IconWrapperProps } from "./IconWrapper";
import { IconWrapper } from "./IconWrapper";

import styles from "./IconBannerCard.module.scss";

export type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5";

export type IconBannerCardProps = {
  title?: string;
  description?: string;
  itemTitleHeadingLevel?: HeadingLevel;
  caption?: string;
  image?: string;
  isBorderVisible?: boolean;
} & IconWrapperProps;

const { sanitize } = dompurify;

export const IconBannerCard: FC<IconBannerCardProps> = ({
  icon: Icon,
  title,
  description,
  itemTitleHeadingLevel = "h2",
  isBorderVisible,
  customIcon,
  caption,
  image,
}) => {
  const isTextWrapperVisible = !!(title || description || caption);

  return (
    <div className={classNames(styles.container, { [styles.withBorder]: isBorderVisible })}>
      <IconWrapper customIcon={customIcon} icon={Icon} />
      {isTextWrapperVisible && (
        <div className={styles.textWrapper}>
          {title && (
            <Typography as={itemTitleHeadingLevel} weight="light" variant="h3">
              {title}
            </Typography>
          )}
          {description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: sanitize(description),
              }}
            />
          )}
          {caption && (
            <div
              className={styles.caption}
              dangerouslySetInnerHTML={{
                __html: sanitize(caption),
              }}
            />
          )}
        </div>
      )}
      {image && <img src={image} alt={title} className={styles.image} />}
    </div>
  );
};
